import React, { Component } from 'react'

import {
    REDUX_ACTION,

    userBinding,
    langChange,
    paymentModeBinding,
    paymentsBinding,
    passwordBinding,
    pointBinding,
    pointTicketBinding,
    uploadImgBloburlBinding,
    couponBinding,
    accountStatusBinding,
    themeBinding,
    likeTemplatesBinding,
    lastViewTemplatesBinding,

    makeStateBinding,
    templatesStateBinding,
    myVideoStateBinding,
    likedVideoStateBinding,
    editorStateBinding,
    galleryStateBinding,
    galleryDetailStateBinding,
    userGalleryStateBinding,
    myGalleryStateBinding,
    orderStateBinding,
    myProfileURLBinding,
    unreadNotiCountBinding,
    notiAvailableBinding,

    loginPopupShowBinding,
    signUpPopupShowBinding,
    currentPathBinding,
    blockUserBinding,
    payemntStateBinding,

    creditsStateBinding,
    creditsProductsStateBinding,

    workspaceCapacityStateBinding
} from '../action'
import { connect } from 'react-redux'

let self

class ReduxInstance extends Component {
    constructor(props) {
        super(props)
        self = this
    }

    render() {
        return null
    }
}

const mapDispatchToProps = dispatch => ({
    userBinding: value => dispatch(userBinding(value)),
    langChange: value => dispatch(langChange(value)),
    paymentModeBinding: value => dispatch(paymentModeBinding(value)),
    paymentsBinding: value => dispatch(paymentsBinding(value)),
    passwordBinding: value => dispatch(passwordBinding(value)),
    pointBinding: value => dispatch(pointBinding(value)),
    pointTicketBinding: value => dispatch(pointTicketBinding(value)),
    uploadImgBloburlBinding: value => dispatch(uploadImgBloburlBinding(value)),
    couponBinding: value => dispatch(couponBinding(value)),
    accountStatusBinding: value => dispatch(accountStatusBinding(value)),
    themeBinding: value => dispatch(themeBinding(value)),
    likeTemplatesBinding: value => dispatch(likeTemplatesBinding(value)),
    lastViewTemplatesBinding: value => dispatch(lastViewTemplatesBinding(value)),

    makeStateBinding: value => dispatch(makeStateBinding(value)),
    templatesStateBinding: value => dispatch(templatesStateBinding(value)),
    myVideoStateBinding: value => dispatch(myVideoStateBinding(value)),
    likedVideoStateBinding: value => dispatch(likedVideoStateBinding(value)),
    editorStateBinding: value => dispatch(editorStateBinding(value)),
    galleryStateBinding: value => dispatch(galleryStateBinding(value)),
    galleryDetailStateBinding: value => dispatch(galleryDetailStateBinding(value)),
    userGalleryStateBinding: value => dispatch(userGalleryStateBinding(value)),
    myGalleryStateBinding: value => dispatch(myGalleryStateBinding(value)),
    orderStateBinding: value => dispatch(orderStateBinding(value)),
    myProfileURLBinding: value => dispatch(myProfileURLBinding(value)),
    unreadNotiCountBinding: value => dispatch(unreadNotiCountBinding(value)),
    notiAvailableBinding: value => dispatch(notiAvailableBinding(value)),
    
    loginPopupShowBinding: value => dispatch(loginPopupShowBinding(value)),
    signUpPopupShowBinding: value => dispatch(signUpPopupShowBinding(value)),

    currentPathBinding: value => dispatch(currentPathBinding(value)),
    blockUserBinding: value => dispatch(blockUserBinding(value)),

    payemntStateBinding: value => dispatch(payemntStateBinding(value)),
    creditsStateBinding: value => dispatch(creditsStateBinding(value)),
    creditsProductsStateBinding: value => dispatch(creditsProductsStateBinding(value)),
    workspaceCapacityStateBinding: value => dispatch(workspaceCapacityStateBinding(value))
})

export default connect(
    null,
    mapDispatchToProps
)(ReduxInstance)

export const ReduxBinding = (action, value) => {
    switch (action) {
        case REDUX_ACTION.USER: return self.props.userBinding(value)
        case REDUX_ACTION.LANG: return self.props.langChange(value)
        case REDUX_ACTION.PAYMENT_MODE: return self.props.paymentModeBinding(value)
        case REDUX_ACTION.PAYMENTS: return self.props.paymentsBinding(value)
        case REDUX_ACTION.PASSWORD: return self.props.passwordBinding(value)
        case REDUX_ACTION.POINT: return self.props.pointBinding(value)
        case REDUX_ACTION.POINT_TICKET: return self.props.pointTicketBinding(value)
        case REDUX_ACTION.UPLOAD_IMG_BLOBURL: return self.props.uploadImgBloburlBinding(value)
        case REDUX_ACTION.COUPON_STATE: return self.props.couponBinding(value)
        case REDUX_ACTION.ACCOUNTSTATUS_STATE: return self.props.accountStatusBinding(value)
        case REDUX_ACTION.THEME: return self.props.themeBinding(value)
        case REDUX_ACTION.LIKE_TEMPLATES: return self.props.likeTemplatesBinding(value)
        case REDUX_ACTION.LASTVIEW_TEMPLATES: return self.props.lastViewTemplatesBinding(value)

        case REDUX_ACTION.MAKE_STATE: return self.props.makeStateBinding(value)
        case REDUX_ACTION.TEMPLATES_STATE: return self.props.templatesStateBinding(value)
        case REDUX_ACTION.MY_VIDEO_STATE: return self.props.myVideoStateBinding(value)
        case REDUX_ACTION.LIKED_VIDEO_STATE: return self.props.likedVideoStateBinding(value)
        case REDUX_ACTION.EDITOR_STATE: return self.props.editorStateBinding(value)
        case REDUX_ACTION.GALLERY_STATE: return self.props.galleryStateBinding(value)
        case REDUX_ACTION.GALLERY_DETAIL_STATE: return self.props.galleryDetailStateBinding(value)
        case REDUX_ACTION.USER_GALLERY_STATE: return self.props.userGalleryStateBinding(value)
        case REDUX_ACTION.MY_GALLERY_STATE: return self.props.myGalleryStateBinding(value)
        case REDUX_ACTION.ORDER_STATE: return self.props.orderStateBinding(value)
        case REDUX_ACTION.MY_PROFILE_URL_STATE: return self.props.myProfileURLBinding(value)
        case REDUX_ACTION.UNREAD_NOTI_COUNT_STATE: return self.props.unreadNotiCountBinding(value)
        case REDUX_ACTION.NOTI_AVAILABLE_STATE: return self.props.notiAvailableBinding(value)

        case REDUX_ACTION.LOGIN_POPUP_SHOW_STATE: return self.props.loginPopupShowBinding(value)
        case REDUX_ACTION.SIGNUP_POPUP_SHOW_STATE: return self.props.signUpPopupShowBinding(value)
        case REDUX_ACTION.CURRENT_PATH_STATE: return self.props.currentPathBinding(value)
        case REDUX_ACTION.BLOCK_USERS: return self.props.blockUserBinding(value)

        case REDUX_ACTION.VIDEO09_PAYMENTS_STATE: return self.props.payemntStateBinding(value)
        case REDUX_ACTION.CREDITS_STATE: return self.props.creditsStateBinding(value)
        case REDUX_ACTION.CREDITS_PRODUCTS_STATE: return self.props.creditsProductsStateBinding(value)
        case REDUX_ACTION.WORKSPACE_CAPACITY_STATE: return self.props.workspaceCapacityStateBinding(value)
        default: return null
    }
}